import { GraduationCap, Users, Award, HeartHandshake } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const FACTS = [
    {
        icon: GraduationCap,
        text: "Absolwentka anglistyki Uniwersytetu Warszawskiego, ponad 20 lat doświadczenia w nauczaniu",
    },
    {
        icon: Award,
        text: "Miłośniczka gier komputerowych, planszówek i RPG; wykorzystuje ich mechanizmy na zajęciach",
    },
    {
        icon: HeartHandshake,
        text: "Uczy w oparciu o zasoby ucznia i jego indywidualne tempo nauki; bliskie są jej założenia neuropedagogiki",
    },
    {
        icon: Users,
        text: "Angażuje uczniów przez humor i kreatywne podejście do nauki",
    },
];

export default function Host() {
    return (
        <section className="py-20 sm:py-28 px-4 sm:px-8" data-testid="host-section">
            <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                <div className="lg:col-span-5 relative order-2 lg:order-1">
                    <Reveal>
                        <div className="relative mx-auto max-w-sm">
                            <div
                                aria-hidden="true"
                                className="absolute -inset-3 rounded-[3rem] border-2 border-dashed border-brand/40 -rotate-2"
                            />
                            <div className="relative overflow-hidden rounded-[2.6rem] shadow-[0_35px_70px_-30px_rgba(143,0,80,0.5)]">
                                <img
                                    src="/assets/gosia.webp"
                                    loading="lazy"
                                    alt="Małgorzata Klecuń"
                                    className="w-full h-[24rem] sm:h-[28rem] object-cover object-top"
                                    data-testid="host-image"
                                />
                            </div>
                            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 rounded-full bg-brand-ink text-white px-6 py-2.5 text-sm font-bold whitespace-nowrap shadow-lg">
                                Twoja prowadząca
                            </div>
                        </div>
                    </Reveal>
                </div>
                <div className="lg:col-span-7 order-1 lg:order-2">
                    <SectionHead
                        index="04"
                        label="Kto poprowadzi webinar"
                        title="Małgorzata Klecuń"
                        lead="Absolwentka anglistyki Uniwersytetu Warszawskiego, z ponad 20-letnim doświadczeniem w nauczaniu. Jej filozofia opiera się na wykorzystywaniu zasobów ucznia i jego indywidualnego tempa nauki, w duchu neuropedagogiki."
                    />
                    <ul className="mt-9 space-y-4">
                        {FACTS.map((f, i) => (
                            <Reveal key={f.text} delay={i * 0.08}>
                                <li
                                    data-testid={`host-fact-${i + 1}`}
                                    className="flex items-start gap-4 rounded-2xl bg-white border border-brand-tint2 px-5 py-4 shadow-[0_10px_25px_-18px_rgba(194,24,91,0.4)]"
                                >
                                    <span className="grid place-items-center w-10 h-10 shrink-0 rounded-xl bg-brand-tint text-brand-deep">
                                        <f.icon className="w-5 h-5" aria-hidden="true" />
                                    </span>
                                    <span className="text-base sm:text-lg font-semibold text-brand-ink leading-relaxed self-center">
                                        {f.text}
                                    </span>
                                </li>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
